import { useFormikContext } from 'formik';
import { InputText } from '@innovyze/stylovyze/lib/components';
import React from 'react';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const UserEmulationForm = () => {
    const { t } = useGlobalization();
    const { values, errors } = useFormikContext();
    return (React.createElement("form", null,
        React.createElement(InputText, { fieldAttrs: {
                name: 'email',
                value: values.email,
            }, textField: {
                name: 'email',
                value: values.email,
                error: !!errors.email,
                label: t('Email Address'),
                helperText: errors?.email,
            } })));
};
